<template>
  <div class="button-edit py-2 px-4">
    <v-text-field class="pt-5" hide-details @input="updateUrl()" v-model="iframeUrl" :label="$t('iframeedit_iframe_url')"></v-text-field>
    <v-text-field type="number" :hint="$t('iframeedit_iframe_height_hint')" persistent-hint :placeholder="$t('iframeedit_iframe_height_placeholder')" @input="updateHeight()" v-model="iframeHeight" :label="$t('iframeedit_iframe_height')"></v-text-field>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'

export default {
  name: 'IframeEdit',
  props: ['height', 'url'],
  data () {
    return {
      iframeHeight: 0,
      iframeUrl: ''
    }
  },
  created () {
    this.iframeUrl = this.sanitizeIframeUrl(this.url)
    this.iframeHeight = this.height
  },
  methods: {
    updateHeight () {
      this.$emit('update:height', this.iframeHeight)
    },

    updateUrl () {
      const sanitizedUrl = this.sanitizeIframeUrl(this.iframeUrl)
      this.$emit('update:url', sanitizedUrl)
    },

    sanitizeIframeUrl (url) {
      try {
        if (!url) return 'https://'

        const rawUrl = url.replace(/["']/g, '').trim()
        if (rawUrl === 'https://') return rawUrl

        const urlObj = new URL(rawUrl)
        const cleanedUrl = urlObj.toString()
        const finalSanitized = DOMPurify.sanitize(cleanedUrl)

        const isSafe = /^(https?:\/\/|\/)/i.test(finalSanitized)

        return isSafe ? finalSanitized : 'https://'
      } catch (e) {
        return 'https://'
      }
    }
  }
}
</script>
